<div
  class="flex flex-row gap-2 h-full"
  *transloco="let t; scope: 'featureAiAssistant'; prefix: 'featureAiAssistant'"
>
  <div class="bd-suggestions">
    @if (visualSuggestions().length === 0 && !refreshing()) {
      <div
        class="bd-suggestions-empty bd-body-regular"
        data-id="ai-assistant-suggestions-empty"
      >
        {{ t('suggestions.empty') }}
      </div>
    }
    @if (visualSuggestions().length > 0) {
      <p-carousel
        #carousel
        class="w-full h-full flex-1 min-h-0"
        tabindex="0"
        [value]="visualSuggestions()"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="false"
        [showNavigators]="false"
        [orientation]="'vertical'"
        [verticalViewPortHeight]="'100%'"
        (keydown)="onCarouselKeydown($event)"
        (wheel)="onCarouselWheel($event)"
      >
        <ng-template pTemplate="item" let-suggestion>
          @if (suggestion) {
            <div
              tabindex="0"
              role="button"
              class="bd-suggestion-item"
              [attr.aria-label]="
                t('suggestions.selectButtonAriaLabel', {
                  name: suggestion.name,
                })
              "
              (click)="onSuggestionSelect(suggestion)"
              (keydown.enter)="onSuggestionSelect(suggestion)"
              (keydown.space)="onSuggestionSpaceKeydown($event, suggestion)"
              [attr.data-id]="'visual-suggestion-' + suggestion.name"
            >
              <div class="bd-suggestion-preview">
                @if (suggestion.previewSvg; as previewSvg) {
                  <img
                    [src]="previewSvg | svgDataUri"
                    [attr.alt]="'Preview of ' + suggestion.name"
                    class="w-full bg-white"
                  />
                }
                <div class="bd-suggestion-footer-overlay">
                  <div
                    class="flex items-center justify-between gap-2 w-full bd-suggestion-footer"
                  >
                    <bd-text-overflow-tooltip
                      class="bd-label-regular bd-suggestion-name bd-ellipsis-text"
                      [text]="suggestion.name"
                      [showDelay]="500"
                      [tooltipPosition]="'bottom'"
                    ></bd-text-overflow-tooltip>
                  </div>
                </div>
              </div>
            </div>
          }
        </ng-template>
      </p-carousel>
    }
    @if (refreshing()) {
      <div
        class="bd-suggestions-loading-overlay"
        data-id="ai-assistant-suggestions-loader"
      >
        <bd-loader
          styleClass="bd-suggestions-loader"
          [noBackground]="true"
        ></bd-loader>
      </div>
    }
  </div>
</div>
